import React from "react";

export function VirtualizationToggleCard({
  isPersisted,
  onToggle,
}: {
  isPersisted: boolean;
  onToggle: (next: boolean) => void;
  label?: string;
}): JSX.Element {
  const toggleLabel = isPersisted ? "Persisted" : "Virtualized";

  return (
    <section className="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white tw-px-4 tw-py-3">
      <button
        type="button"
        onClick={() => onToggle(!isPersisted)}
        aria-pressed={isPersisted}
        aria-label="Toggle virtualized construct"
        className={`tw-relative tw-inline-flex tw-h-7 tw-w-14 tw-items-center tw-rounded-full tw-transition ${
          isPersisted ? "tw-bg-[#03234a]" : "tw-bg-slate-300"
        }`}
      >
        <span
          className={`tw-inline-block tw-h-6 tw-w-6 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-transition ${
            isPersisted ? "tw-translate-x-7" : "tw-translate-x-1"
          }`}
        />
      </button>
      <div>
        <span
          className={`tw-text-sm tw-font-semibold ${
            isPersisted ? "tw-text-[#03234a]" : "tw-text-slate-500"
          }`}
        >
          {toggleLabel}
        </span>
      </div>
    </section>
  );
}
